const clampScore = (score) => Math.max(1, Math.min(10, score));

const HEALTH_RULES = [
  {
    id: 'thuong_quan_strong',
    condition: { tenGods: { ThuongQuan: { min: 2 } } },
    impact: -2,
    note: 'Thương Quan mạnh, dễ gặp va chạm hoặc phẫu thuật',
    recommendations: ['Giữ an toàn khi vận động', 'Khám sức khỏe định kỳ'],
    explanation: 'Thương Quan mạnh biểu thị năng lượng bộc phát, dễ va chạm nếu thiếu kiểm soát.'
  },
  {
    id: 'hinh_hai',
    condition: { interactionSum: { keys: ['hinh', 'hai'], min: 2 } },
    impact: -1,
    note: 'Tương tác Hình/Hại tăng, dễ gây mỏi mệt kéo dài',
    recommendations: ['Giữ nhịp sinh hoạt ổn định'],
    explanation: 'Nhiều tương tác bất lợi làm cơ thể dễ suy giảm sức đề kháng.'
  }
];

const ELEMENT_WARNINGS = [
  ['Hoa', 'Thiếu Hỏa, hệ tim mạch dễ yếu', 'Tăng vận động tim mạch nhẹ'],
  ['Kim', 'Thiếu Kim, hệ hô hấp/da dễ yếu', 'Giữ ấm đường hô hấp'],
  ['Thuy', 'Thiếu Thủy, thận/sinh dục dễ yếu', 'Uống đủ nước'],
  ['Moc', 'Thiếu Mộc, gan mật/gân xương dễ yếu', 'Ăn nhiều rau xanh'],
  ['Tho', 'Thiếu Thổ, tiêu hóa dễ kém', 'Ăn uống điều độ']
];

const meetsMin = (value, min) => (Number.isFinite(min) ? (value || 0) >= min : true);

const matchesCondition = (condition, { tenGodCounts, interactionCounts } = {}) => {
  if (!condition) return true;

  if (condition.tenGods) {
    const matches = Object.entries(condition.tenGods).every(([key, rule]) => (
      meetsMin(tenGodCounts?.[key], rule?.min)
    ));
    if (!matches) return false;
  }

  if (condition.interactionSum) {
    const { keys = [], min } = condition.interactionSum;
    const total = keys.reduce((sum, key) => sum + (interactionCounts?.[key] || 0), 0);
    if (!meetsMin(total, min)) return false;
  }

  return true;
};

export function healthRule({ fiveElements, tenGodCounts, interactionCounts } = {}) {
  const notes = [];
  const recommendations = [];
  const reasoning = [];
  let score = 8;
  const interactionSum = ['hinh', 'hai'].reduce(
    (sum, key) => sum + (interactionCounts?.[key] || 0),
    0
  );

  HEALTH_RULES.forEach((rule) => {
    if (!matchesCondition(rule.condition, { tenGodCounts, interactionCounts })) return;
    score += rule.impact;
    notes.push(rule.note);
    recommendations.push(...(rule.recommendations || []));
    reasoning.push({
      factor: rule.note,
      impact: rule.impact,
      explanation: rule.id === 'hinh_hai'
        ? `${rule.explanation} (Tổng Hình/Hại: ${interactionSum}).`
        : rule.explanation
    });
  });

  ELEMENT_WARNINGS.forEach(([element, warning, advice]) => {
    if (fiveElements?.[element] === 0) {
      score -= 1;
      notes.push(warning);
      recommendations.push(advice);
      reasoning.push({
        factor: `Thiếu ${element}`,
        impact: -1,
        explanation: warning
      });
    }
  });

  return {
    rating: clampScore(score),
    nhanXet: notes.length ? notes.join('; ') : 'Sức khỏe ổn định',
    khuyenNghi: recommendations,
    reasoning
  };
}
